/* ============================================================
   dun-quick-add.js
   "Agregar al carrito" mini-modal for the dun collection grid.
   Cart integration uses the same event pattern as dun-pdp-main:
   POST /cart/add.js with `sections` + dispatch shapes:cart:afteradditem
   and theme:update:cart so the Shapes drawer/counter refresh.
   ============================================================ */
(function () {
  'use strict';

  const moneyFormat = (window.Shopify && window.Shopify.money_format) || '${{amount}}';

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    const value = (cents / 100).toLocaleString('es-CL', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return '$' + value;
  }

  // ── Modal singleton ────────────────────────────────────────
  let modalEl = null;
  let state = { product: null, variantId: null, qty: 1 };

  function ensureModal() {
    if (modalEl) return modalEl;
    modalEl = document.createElement('div');
    modalEl.className = 'td-modal';
    modalEl.setAttribute('role', 'dialog');
    modalEl.setAttribute('aria-modal', 'true');
    modalEl.setAttribute('aria-hidden', 'true');
    modalEl.innerHTML = `
      <div class="td-modal__panel">
        <button class="td-modal__close" data-td-close aria-label="Cerrar">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M4 4l8 8M12 4l-8 8"/></svg>
        </button>
        <div class="td-modal__head">
          <div class="td-modal__media" data-td-media></div>
          <div style="flex:1;padding-top:6px">
            <div class="td-modal__eyebrow">Agregar al carrito</div>
            <h3 class="td-modal__title" data-td-title></h3>
            <p class="td-modal__desc" data-td-desc></p>
            <div class="td-modal__price" data-td-price></div>
          </div>
        </div>
        <div class="td-modal__variants" data-td-variants hidden>
          <span class="td-modal__label">Variante</span>
          <div class="td-modal__variant-list" data-td-variant-list></div>
        </div>
        <div class="td-modal__actions">
          <div class="td-modal__qty">
            <button type="button" data-td-qty-dec aria-label="Disminuir cantidad">–</button>
            <span data-td-qty>1</span>
            <button type="button" data-td-qty-inc aria-label="Aumentar cantidad">+</button>
          </div>
          <button type="button" class="td-modal__confirm" data-td-confirm>
            <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h2l1.4 8.2a1.5 1.5 0 0 0 1.5 1.3h6.2a1.5 1.5 0 0 0 1.5-1.2L16 5H5"/><circle cx="6.5" cy="14" r=".8" fill="currentColor"/><circle cx="12.5" cy="14" r=".8" fill="currentColor"/></svg>
            <span data-td-confirm-label>Añadir</span>
          </button>
        </div>
      </div>
    `;
    document.body.appendChild(modalEl);

    // Bindings
    modalEl.addEventListener('click', (e) => {
      if (e.target === modalEl || e.target.closest('[data-td-close]')) closeModal();
    });
    modalEl.querySelector('[data-td-qty-dec]').addEventListener('click', () => {
      state.qty = Math.max(1, state.qty - 1);
      renderQty();
    });
    modalEl.querySelector('[data-td-qty-inc]').addEventListener('click', () => {
      state.qty += 1;
      renderQty();
    });
    modalEl.querySelector('[data-td-confirm]').addEventListener('click', confirmAdd);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modalEl.classList.contains('is-open')) closeModal();
    });

    return modalEl;
  }

  function openModal() {
    ensureModal();
    modalEl.classList.add('is-open');
    modalEl.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    if (!modalEl) return;
    modalEl.classList.remove('is-open');
    modalEl.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderQty() {
    if (!modalEl || !state.product) return;
    modalEl.querySelector('[data-td-qty]').textContent = state.qty;
    const v = state.product.variants.find((x) => x.id === state.variantId) || state.product.variants[0];
    modalEl.querySelector('[data-td-confirm-label]').textContent =
      'Añadir · ' + formatMoney(v.price * state.qty);
  }

  function renderModal(product) {
    state.product = product;
    state.variantId = product.variants.find((v) => v.available)?.id || product.variants[0].id;
    state.qty = 1;

    const $ = (sel) => modalEl.querySelector(sel);

    // Media
    const media = $('[data-td-media]');
    media.innerHTML = product.featured_image
      ? `<img src="${product.featured_image}" alt="${product.title}">`
      : `<div style="width:100%;height:100%;display:grid;place-items:center;color:rgba(14,19,48,.55);font-size:10px;text-transform:uppercase;letter-spacing:.08em">${product.title}</div>`;

    $('[data-td-title]').textContent = product.title;
    $('[data-td-desc]').textContent = product.description
      ? product.description.replace(/<[^>]+>/g, '').slice(0, 120)
      : '';

    const v = product.variants.find((x) => x.id === state.variantId);
    const price = $('[data-td-price]');
    if (v.compare_at_price && v.compare_at_price > v.price) {
      price.innerHTML = `<span class="td-modal__price--was">${formatMoney(v.compare_at_price)}</span>${formatMoney(v.price)}`;
    } else {
      price.innerHTML = formatMoney(v.price);
    }

    // Variants
    const variantsBlock = $('[data-td-variants]');
    const variantList = $('[data-td-variant-list]');
    variantList.innerHTML = '';
    if (product.variants.length > 1) {
      variantsBlock.hidden = false;
      product.variants.forEach((variant) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'td-modal__variant' + (variant.id === state.variantId ? ' is-active' : '');
        btn.textContent = variant.title;
        btn.dataset.variantId = variant.id;
        btn.disabled = !variant.available;
        if (!variant.available) {
          btn.title = 'Sin stock';
          btn.style.opacity = '.5';
        }
        btn.addEventListener('click', () => {
          state.variantId = variant.id;
          variantList.querySelectorAll('.td-modal__variant').forEach((b) => b.classList.remove('is-active'));
          btn.classList.add('is-active');
          renderQty();
        });
        variantList.appendChild(btn);
      });
    } else {
      variantsBlock.hidden = true;
    }

    renderQty();
  }

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`, { headers: { 'Accept': 'application/json' }});
    if (!res.ok) throw new Error('No se pudo cargar el producto');
    return res.json();
  }

  // Shared add-to-cart: POSTs the line item, notifies Shapes (which opens the
  // side drawer via ModalCart when settings.open_modal_on_add_to_cart is on),
  // and gives feedback on the card button. Used both by the direct-add path
  // (single-variant products) and the modal confirm (multi-variant products).
  async function addToCart(variantId, qty, triggerBtn) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: qty }],
        sections: 'cart-items,cart-footer,cart-item-count',
        sections_url: window.location.pathname,
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.status) {
      throw new Error(data.description || 'Error al agregar');
    }

    // Notify Shapes so the cart drawer opens + counter updates (same as dun-pdp-main)
    document.body.dispatchEvent(new CustomEvent('shapes:cart:afteradditem', {
      bubbles: true, detail: { response: data, sourceId: 'dun-quick-add' }
    }));
    document.dispatchEvent(new CustomEvent('theme:update:cart'));

    // Feedback on the card button that triggered the add
    if (triggerBtn) {
      triggerBtn.classList.add('is-added');
      const label = triggerBtn.querySelector('span');
      if (label) {
        const original = label.textContent;
        label.textContent = '¡Añadido!';
        setTimeout(() => {
          triggerBtn.classList.remove('is-added');
          label.textContent = original;
        }, 1500);
      }
    }

    return data;
  }

  async function confirmAdd() {
    if (!state.product || !state.variantId) return;
    const btn = modalEl.querySelector('[data-td-confirm]');
    btn.disabled = true;

    try {
      await addToCart(state.variantId, state.qty, state.triggerBtn);
      closeModal();
    } catch (e) {
      alert(e.message || 'No se pudo agregar al carrito');
    } finally {
      btn.disabled = false;
    }
  }

  // ── Delegation: click on any .td-card__add ─────────────────
  // Single-variant products add straight to cart and open the side drawer;
  // no mini-modal. Multi-variant products still open the modal so the customer
  // can pick a variant before adding.
  document.addEventListener('click', async (e) => {
    const trigger = e.target.closest('.td-card__add');
    if (!trigger) return;
    e.preventDefault();

    const handle = trigger.dataset.productHandle;
    if (!handle) return;

    state.triggerBtn = trigger;

    trigger.disabled = true;
    try {
      const product = await fetchProduct(handle);

      if (product.variants.length > 1) {
        // Needs a variant choice → open the modal.
        ensureModal();
        renderModal(product);
        openModal();
      } else {
        // Single variant → add directly, drawer opens via the dispatched event.
        const variant = product.variants.find((v) => v.available) || product.variants[0];
        await addToCart(variant.id, 1, trigger);
      }
    } catch (err) {
      console.error(err);
      alert(err.message || 'No se pudo agregar al carrito');
    } finally {
      trigger.disabled = false;
    }
  });

  // ── Variant chips inside the card (UI only, no add) ────────
  document.addEventListener('click', (e) => {
    const chip = e.target.closest('.td-chip');
    if (!chip) return;
    const card = chip.closest('.td-card');
    if (!card) return;
    card.querySelectorAll('.td-chip').forEach((c) => {
      c.classList.remove('is-active');
      c.setAttribute('aria-checked', 'false');
    });
    chip.classList.add('is-active');
    chip.setAttribute('aria-checked', 'true');
  });
})();
